import React, { useEffect, useState } from "react";
import { CLOSED } from "../../utils/constants";

const DisputeWindowTime = ({ claimNotDisputed, decideWinnerEndTime, claimEligibility, setClaimNotDisputed, disputeOrAppealText, setPoolStatus, isAppealed }) => {
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const poolEndTimestamp = Math.floor(new Date(decideWinnerEndTime)?.getTime() / 1000);
      const currentTime = Math.floor(Date.now() / 1000);
      const secondsSincePoolEnd = currentTime - poolEndTimestamp;
      const remaining = claimEligibility - secondsSincePoolEnd;

      if (remaining <= 0) {
        setSecondsLeft(0);
        setClaimNotDisputed(false);
        if (!isAppealed) {
          setPoolStatus(CLOSED);
        }
        clearInterval(interval);
      } else {
        setSecondsLeft(remaining);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [decideWinnerEndTime, claimEligibility, setClaimNotDisputed]);

  const hrs = Math.floor(secondsLeft / 3600);
  const mins = Math.floor((secondsLeft % 3600) / 60);
  const secs = secondsLeft % 60;
  const disputeEndsTime = `${hrs > 0 ? hrs + "h " : ""}${mins}m ${secs}s`;

  return (
    <div>
      {claimNotDisputed && secondsLeft > 0 && (
        <>
          <p > {disputeEndsTime} </p>
        </>
      )
      }
    </div >
  );
}
export default DisputeWindowTime;